export default __webpack_public_path__ + "static/media/section3-pic7.81f42ffa.png";